import React from "react";
import styled from "styled-components";
import classnames from "classnames";

const ButtonPlain = styled.button`
  background: #f37021;
  color: #fff;
  font-size: 15px;
  padding: 12px 20px;
  border-radius: 25px;
  display: inline-block;
  border: 1px solid #f37021;
  transition: All 0.5s;
  min-width: 120px;
  text-align: center;
  outline: 0;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  white-space: normal;

  &.small {
    font-size: 14px;
  }

  &:hover {
    color: #f37021 !important;
    background-color: #fff;
  }

  &.inversed {
    color: #f37021 !important;
    background-color: #fff;

    &:hover {
      color: #ffffff !important;
      background: #f37021;
    }
  }
`;

const ButtonLink = styled.a`
  background: #f37021;
  color: #fff;
  font-size: 15px;
  padding: 12px 20px;
  border-radius: 25px;
  display: inline-block;
  border: 1px solid #f37021;
  transition: All 0.5s;
  min-width: 120px;
  text-align: center;
  outline: 0;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  white-space: normal;

  &.small {
    font-size: 14px;
  }

  &:hover {
    color: #f37021 !important;
    background-color: #fff;
  }

  &.inversed {
    color: #f37021 !important;
    background-color: #fff;

    &:hover {
      color: #ffffff !important;
      background: #f37021;
    }
  }
`;

function Button(props) {
  const { href, type, style, size = "regular" } = props;
  let classNames = { inversed: style };
  classNames[size] = size;

  if (href) {
    return (
      <ButtonLink href={href} className={classnames(classNames)}>
        {props.children}
      </ButtonLink>
    );
  } else {
    return (
      <ButtonPlain type={type} className={classnames(classNames)}>
        {props.children}
      </ButtonPlain>
    );
  }
}

export default Button;
